// src/pages/documents/RulesFI.js
          //this will be painful to update
import React from 'react';

const SaferSpacePrinciples = () => {
  return (
    <div className="page rules-page">
      <section className="page-header">
        <div className="container">
          <h1>Principles of Equality and Safer Space</h1>
          <p>Updated 2026</p>
          
        </div>
      </section>
      <section className="content-section">
        <div className="container">

          <div className="rule-card">
            
            <p>Integralis events follow these principles to ensure that everyone feels safe, respected, and
welcome:</p>
<ul>
  <li>In problem situations, ask for help from the person in charge of the event or a
harassment contact person.</li>
<li>Call 112 in emergency situations.</li>
<li>Take care of yourself and the people around you (for example, make sure you and
others can get home safely). If someone needs help, do not ignore the situation—help
them or seek assistance.</li>
<li>Treat every person with respect and dignity. Respect others’ physical and emotional
boundaries, and do not make assumptions about anyone’s gender, sexual identity,
nationality, ethnicity, or other personal characteristics.</li>
<li>Do not discriminate, harass, bully, or touch others without consent. Remember: “no”
is always valid, and you cannot know someone’s boundaries without asking.</li>
<li>If you experience or witness harassment or discrimination, contact the event
organizers or harassment contact persons (in person or online), or file a harassment
report (the form is available on the Integralis website).</li>
<li>Respect confidentiality. Do not share other people’s personal experiences or
information without their consent.</li>
<li>Be mindful and inclusive when using a language other may not understand. Do not
speak ill about others in a language they don’t understand.</li>
<li>Everyone is responsible for maintaining a safer space. If you notice inappropriate
behavior, address it if it is safe to do so or report it.</li>
<li>Retaliation against anyone who reports harassment or sets boundaries is not tolerated.</li>
<li>Violations of these principles may result in consequences ranging from a warning or
removal from an event to temporary or permanent bans, revocation of membership, or
contacting the authorities if a crime is suspected.</li>
</ul>
<br></br>
<p>Questions and comments regarding the safer space principles can be sent
to integralis@helsinki.fi.</p>

<p>Integralis’ harassment contact people are: </p>
<ul>
  <li>Çiçek Aykaç</li>
  <li>Arjun Menon Tiwari</li>
  <li>Hendrik Erik Raidal</li>
</ul>


          </div>
        </div>
      </section>
    </div>
  );
};

export default SaferSpacePrinciples;

